import { Outlet } from "react-router-dom";
import { House, LayoutList, Rss, ShieldUser } from "lucide-react";
import { NavItem } from "@/components/layout/Menu/MenuGridIcon";
import { MenuRowIcon } from "@/components/layout/Menu/MenuRowIcon";
import { Roles } from "iasma-datatypes";
import { CommunityManagementForm, CommunityManagementList } from "@/components/communities/CommunityManagement";

export function CommunityMenu() {
	const navItems: NavItem[] = [
		{ label: 'Home', to: '/', icon: <House size={32} /> },
		{ label: 'Index', to: '/community/list', icon: <LayoutList size={32} /> },
		{ label: 'Berita', to: '/community/news', icon: <Rss size={32} /> },
		{ 
			label: 'Administrasi', to: '/community/admin', icon: <ShieldUser size={32} />,
			roles: [Roles.ADMIN_ANGKATAN, Roles.ADMIN_ALL]  
		},
	];

	return <>
		<MenuRowIcon menus={navItems} backpath="/" />
		<div className="p-2">
			<Outlet />
		</div>
	</>
}

export function CommunityList() {
	return <pre>
- Community List<br />
--- IASMA Pusat/Daerah/Regional<br />
--- Pengajian<br />
--- Olahraga/Hobby<br />
--- Kampus<br />
	</pre>
}


export function CommunityNews() {
	return <pre>
- Community News<br />
--- Subcribe a community news<br />
--- Posting Community News (by admin)<br />
--- Post comment on news (all community member)<br />
	</pre>
}

export function CommunityAdmin() {
	return <CommunityManagementList />;
}

export function CommunityAdminAdd() {
	return <CommunityManagementForm />;
}

export function CommunityAdminEdit() {
	return <CommunityManagementForm />;
}

